import identityDatashape from "./identity.datashape";
import shareholderIdentityDatashape from "./shareholderIdentity.datashape";

const profileDatashape = `
  ... on ProviderPersonalProfileType {
    entityType
    accountType
    identity {
      ${identityDatashape}
    }
    businessAddress {
      address
      city
      country
      primaryPhone
      secondaryPhone
      email
      website
    }
    personalDetails {
      fullName { first middle last }
      motherName { first middle last }
      placeOfBirth
      dateOfBirth
      nationality
      countryOfResidence
      maritalStatus
      spouseName { first middle last }
    }
    professionDetails {
      status
      profession
      employerName
      businessActivity
    }
    residentialAddress {
      address
      city
      country
      primaryPhone
      secondaryPhone
      email
    }
  }

  ... on RecipientPersonalProfileType {
    entityType
    accountType
    identity {
      ${identityDatashape}
    }
    personalDetails {
      fullName { first middle last }
      motherName { first middle last }
      placeOfBirth
      dateOfBirth
      nationality
      countryOfResidence
      maritalStatus
      spouseName { first middle last }
    }
    professionDetails {
      status
      profession
      employerName
      businessActivity
    }
    residentialAddress {
      address
      city
      country
      primaryPhone
      secondaryPhone
      email
    }
    businessAddress {
      address
      city
      country
      primaryPhone
      secondaryPhone
      email
      website
    }
    personalFinancialDetails {
      income
      incomePeriodicity { value otherDetails }
      sourcesOfIncome { source otherDetails }
      totalLiabilities { applicable amount }
      totalFixedAssets { applicable amount }
    }
    personalEvidencingDocuments {
      type
      otherDetails
      document
    }
    relationsWithBanks {
      name
      country
    }
  }

  ... on ProviderCorporationProfileType {
    entityType
    accountType
    corporationDetails {
      name
      businessActivity
      typeOfTradingBusiness
      registrationNumber
      placeOfRegistration
      dateOfRegistration
      countryOfAuthority
      registrationDocument
      legalForm
    }
    shareholders {
      name { first middle last }
      percentage
      nationality
      identity {
        ${shareholderIdentityDatashape}
      }
    }
    businessAddress {
      address
      city
      country
      primaryPhone
      secondaryPhone
      email
      website
    }
  }

  ... on RecipientCorporationProfileType {
    entityType
    accountType
    corporationDetails {
      name
      businessActivity
      typeOfTradingBusiness
      registrationNumber
      placeOfRegistration
      dateOfRegistration
      countryOfAuthority
      registrationDocument
      legalForm
    }
    shareholders {
      name { first middle last }
      percentage
      nationality
      identity {
        ${shareholderIdentityDatashape}
      }
    }
    businessAddress {
      address
      city
      country
      primaryPhone
      secondaryPhone
      email
      website
    }
    corporationEvidencingDocuments {
      type
      otherDetails
      document
    }
    corporationFinancialDetails {
      totalSales { previousYear expected }
      netProfit { previousYear expected }
      exportSales { previousYear expected }
      receivables { applicable amount }
      inventory { applicable amount }
      fixedAssets { applicable amount }
      bankDebt { applicable amount }
      otherDebt { applicable amount }
    }
    majorClients {
      name
      country
    }
    majorSuppliers {
      name
      country
    }
    relationsWithBanks {
      name
      country
    }
  }
`;

export default profileDatashape;
